import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import {
    dataPointersUpdate,
    dataPointersCleanUp,
} from '~spa/SpectateStore/actions/dataPointersActions';
import { eventDataCleanUp } from '~SpectateStore/actions/eventDataCleanUp';
import { marketSwitcherUpdate } from '~SpectateStore/actions/marketSwitcherUpdate';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';


export const dataPointersAdapter = createEntityAdapter();

const dataPointersSlice = createSlice({
    name: 'dataPointers',
    initialState: dataPointersAdapter.getInitialState(),
    reducers: {
        addDataPointers: dataPointersAdapter.addOne,
        removeDataPointers: dataPointersAdapter.removeOne,
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                dataPointersUpdate,
                (state, { payload : { dataPointers = {} } }) => {
                    if (Object.keys(dataPointers).length > 0) {
                        return dataPointersAdapter.setOne(state, dataPointers);
                    }

                    return state;
                },
            )
            .addCase(
                dataPointersCleanUp,
                (state, { payload: { dataPointersId } }) => {
                    return dataPointersAdapter.removeOne(state, dataPointersId);
                },
            )
            .addCase(
                eventDataCleanUp,
                (state, { payload : { eventId } }) => {
                    const updatedEntities = [];
                    Object.values(state.entities).forEach(({ id, pointers = [], eventOrder = []}) => {

                        if (!pointers.some(({ event_id }) => event_id === eventId)) {
                            return;
                        }

                        const updatedPointers = pointers.filter(pointer => pointer.event_id !== eventId);
                        const updatedEventOrder = eventOrder.filter(event_id => event_id !== eventId);

                        const updateData = {
                            id,
                            changes: {
                                pointers: updatedPointers,
                                eventOrder: updatedEventOrder,
                            },
                        };

                        updatedEntities.push(updateData);
                    });

                    return dataPointersAdapter.updateMany(state, updatedEntities);
                },
            )
            .addCase(
                marketSwitcherUpdate,
                (state, { payload: { dataPointers } }) => {
                    const { id, pointers } = dataPointers;
                    // Updates only the pointers, keeping the existing order of events
                    dataPointersAdapter.updateOne(state, {
                        id,
                        changes: {
                            pointers,
                        },
                    });
                }
            )
            .addCase(
                eventInplayStart,
                (state, { payload : { dataPointers } }) => {
                    Object.entries(dataPointers).forEach(([entityId, data]) => {
                        const { eventOrder, pointers } = data;

                        dataPointersAdapter.updateOne(state, {
                            id: entityId,
                            changes: {
                                eventOrder,
                                pointers,
                            },
                        });
                    });
                },
            );
    },
});

export const { addDataPointers, removeDataPointers } = dataPointersSlice.actions;
export default dataPointersSlice.reducer;
